import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import styled, { createGlobalStyle } from 'styled-components';
import { white } from '../../utils/styles';
import { Footer, FOOTER_HEIGHT, Header, HEADER_HEIGHT } from './';

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: ${HEADER_HEIGHT};
`;

const Main = styled.main`
  min-height: calc(100vh - ${HEADER_HEIGHT} - ${FOOTER_HEIGHT});
  width: 100%;
`;

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${white};
  }
`;

export const BODY_WIDTH = '840px';

export const Layout: FC = ({ children }) => (
  <StyledLayout>
    <Helmet>
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
    </Helmet>
    <GlobalStyle />
    <Header />
    <Main>{children}</Main>
    <Footer />
  </StyledLayout>
);
